import { IconButton } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import * as Images from '../../../../images';
import * as Style from './style';
const Header = () => {
  return (
    <Style.HederSection>
      <IconButton component={Link} to={'/'}  >
        <img src={Images.ArrowRight} alt="" />
      </IconButton>
      <Style.HederText>
        الدعم
      </Style.HederText>
    </Style.HederSection>
  )
}

export default Header